/**
 * Fishermans — Depoimentos (carrossel).
 * Extraido do carrossel generico de fishermans-v3-pdp.js.
 *
 * IMPORTANTE: raiz propria [data-fm-depo] (nao [data-fm-v2-pdp]).
 * A v2/v3 faz document.querySelector("[data-fm-v2-pdp]") e retorna cedo se
 * nao achar — se esta secao usasse o mesmo atributo, os dois scripts brigariam
 * pela primeira raiz do DOM e um dos dois morreria.
 * E aqui percorremos TODAS as raizes, para a secao poder repetir na pagina.
 */
(function () {
  document.querySelectorAll("[data-fm-depo]").forEach(function (root) {
    root.querySelectorAll("[data-fm-carousel]").forEach(function (carousel) {
      var track = carousel.querySelector("[data-fm-carousel-track]");
      var prevBtn = carousel.querySelector("[data-fm-carousel-prev]");
      var nextBtn = carousel.querySelector("[data-fm-carousel-next]");
      if (!track || !prevBtn || !nextBtn) return;
      var items = Array.from(track.children);
      if (!items.length) return;
      var current = 0;
      var desktopPer = parseInt(carousel.getAttribute("data-fm-carousel"), 10) || 3;

      function perPage() { return window.innerWidth >= 990 ? desktopPer : 1; }
      function maxIdx() { return Math.max(0, items.length - perPage()); }

      function stride() {
        if (items.length > 1) {
          return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
        }
        return items[0].getBoundingClientRect().width;
      }

      function goTo(n) {
        current = Math.max(0, Math.min(n, maxIdx()));
        track.style.transform = "translateX(" + (-current * stride()) + "px)";
        var max = maxIdx();
        prevBtn.hidden = nextBtn.hidden = max === 0;
        prevBtn.disabled = current === 0;
        nextBtn.disabled = current >= max;
      }

      prevBtn.addEventListener("click", function () { goTo(current - 1); });
      nextBtn.addEventListener("click", function () { goTo(current + 1); });

      var rTimer;
      window.addEventListener("resize", function () {
        clearTimeout(rTimer);
        rTimer = setTimeout(function () { goTo(Math.min(current, maxIdx())); }, 100);
      });

      goTo(0);
    });
  });
})();
